import type { ActionTree } from "vuex";
import {
  LOAD_SCENARIOS_BY_PLACE,
  LOAD_SCENARIOS_BY_PLACE_SUCCESS,
  LOAD_SCENARIOS_BY_PLACE_FAILURE,
  LOAD_SCENARIOS_BY_ID,
  LOAD_SCENARIOS_BY_ID_SUCCESS,
  LOAD_SCENARIOS_BY_ID_FAILURE,
  ADD_SCENARIO_BY_PLACE,
  ADD_SCENARIO_SUCCESS_BY_PLACE,
  ADD_SCENARIO_FAILURE_BY_PLACE,
  UPDATE_SCENARIO_BY_PLACE,
  UPDATE_SCENARIO_SUCCESS_BY_PLACE,
  UPDATE_SCENARIO_FAILURE_BY_PLACE,
  DELETE_SCENARIO_BY_PLACE,
  DELETE_SCENARIO_SUCCESS_BY_PLACE,
  DELETE_SCENARIO_FAILURE_BY_PLACE,
} from "./mutations";
import { httpClient, type AxiosResponse } from "@/services/httpClient";
import type { RootState, ScenarioState, Scenario } from "@/types";
import { HOSTS, ENDPOINTS } from "@/constants";

export const actions: ActionTree<ScenarioState, RootState> = {
  fetchScenariosByPlace({ commit }, placeId: string) {
    commit(LOAD_SCENARIOS_BY_PLACE);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.SCENARIOS}`, {
        params: { placeId },
      })
      .then(
        (response: AxiosResponse<Scenario[]>) => {
          commit(LOAD_SCENARIOS_BY_PLACE_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_SCENARIOS_BY_PLACE_FAILURE, error.message);
        },
      );
  },
  fetchScenariosById({ commit }, scenarioId: string) {
    commit(LOAD_SCENARIOS_BY_ID);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.SCENARIOS}`, {
        params: { scenarioId },
      })
      .then(
        (response: AxiosResponse<Scenario[]>) => {
          commit(LOAD_SCENARIOS_BY_ID_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_SCENARIOS_BY_ID_FAILURE, error.message);
        },
      );
  },

  addScenario({ commit }, scenario: Scenario) {
    commit(ADD_SCENARIO_BY_PLACE);
    httpClient.post(`${HOSTS.AWS}/${ENDPOINTS.SCENARIOS}`, scenario).then(
      (response: AxiosResponse<Scenario>) => {
        commit(ADD_SCENARIO_SUCCESS_BY_PLACE, response.data);
      },
      (error) => {
        commit(ADD_SCENARIO_FAILURE_BY_PLACE, error.message);
      },
    );
  },
  updateScenario({ commit }, scenario: Scenario) {
    commit(UPDATE_SCENARIO_BY_PLACE);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.SCENARIOS}/${scenario?.id}`, {
        ...scenario,
        id: undefined,
        deletable: undefined,
      })
      .then(
        (response: AxiosResponse<Scenario>) => {
          commit(UPDATE_SCENARIO_SUCCESS_BY_PLACE, response.data);
        },
        (error) => {
          commit(UPDATE_SCENARIO_FAILURE_BY_PLACE, error.message);
        },
      );
  },
  deleteScenario({ commit }, scenario: Scenario) {
    commit(DELETE_SCENARIO_BY_PLACE);
    httpClient
      .delete(`${HOSTS.AWS}/${ENDPOINTS.SCENARIOS}/${scenario.id}`)
      .then(
        () => {
          commit(DELETE_SCENARIO_SUCCESS_BY_PLACE, scenario);
        },
        (error) => {
          commit(DELETE_SCENARIO_FAILURE_BY_PLACE, error.message);
        },
      );
  },
};
